import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab } from '@mui/material';
import { Gavel as DecisionsIcon, Description as DocsIcon } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import ReliabilityDecisions from './ReliabilityDecisions';
import ReliabilityDocumentation from './ReliabilityDocumentation';

const PRIMARY = '#1A2E22';
const SUB_TAB_MAP = { decisions: 0, documentation: 1 };

const ReliabilityAssets = () => {
  const [searchParams] = useSearchParams();
  const initialSubTab = searchParams.get('subTab');
  const [subTab, setSubTab] = useState(
    initialSubTab && SUB_TAB_MAP[initialSubTab] !== undefined ? SUB_TAB_MAP[initialSubTab] : 0
  );

  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          mb: 3,
          borderRadius: '16px',
          overflow: 'hidden',
          border: '1.5px solid rgba(0,0,0,0.08)'
        }}
      >
        <Tabs
          value={subTab}
          onChange={(_, v) => setSubTab(v)}
          sx={{
            px: 1,
            '& .MuiTab-root': {
              minHeight: 52,
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.9rem',
              color: '#666666',
              gap: 0.75,
              '&.Mui-selected': { color: PRIMARY, fontWeight: 600 }
            },
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: '3px 3px 0 0',
              bgcolor: PRIMARY
            }
          }}
        >
          <Tab
            icon={<DecisionsIcon fontSize="small" />}
            label="Decisions"
            iconPosition="start"
            aria-label="Decisions sub-tab"
          />
          <Tab
            icon={<DocsIcon fontSize="small" />}
            label="Documentation"
            iconPosition="start"
            aria-label="Documentation sub-tab"
          />
        </Tabs>
      </Paper>

      {subTab === 0 && <ReliabilityDecisions />}
      {subTab === 1 && <ReliabilityDocumentation />}
    </Box>
  );
};

export default ReliabilityAssets;
